import { useContext, useMemo } from 'react'
import GlobalContext from '../../../../../../../common/context/GlobalContext'

const RoleRenderer = ({ row }) => {

  const { iamReducer = {}, treeReducer } = useContext(GlobalContext)
  const { roleMap = {}, customRoleMap = {} } = iamReducer
  const { selectedTreeNode } = treeReducer

  const sortedPolicies = useMemo(() => {
    const policies = row?.original?.policies
    return policies.sort((policy_a, policy_b) => {
      if (policy_a.inherited_from === selectedTreeNode?.id) {
        return -1
      }
      if (policy_b.inherited_from === selectedTreeNode?.id) {
        return 1
      }
      return 0
    }, [])
  }, [row?.original?.policies, selectedTreeNode])

  return (
    <div className='tw-flex tw-flex-col tw-gap-0.5 tw-h-full tw-w-full tw-p-1'>
      {sortedPolicies?.map(({ role }, index) => (
        <div key={index} className='tw-flex-1 tw-flex'>
          {customRoleMap[role]?.label || customRoleMap[role]?.name || roleMap[role]?.label || role}
        </div>
      ))}
    </div>
  )
}

RoleRenderer.propTypes = {}
export default RoleRenderer
